import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ChartModule } from 'primeng/chart';
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { TranslocoService } from '@jsverse/transloco';

export interface FieldErrorChartItem {
  label: string;
  not_extracted: number;
  wrong_value: number;
}

@Component({
  selector: 'app-qa-field-errors-chart',
  standalone: true,
  imports: [ChartModule],
  templateUrl: './qa-field-errors-chart.component.html',
  styleUrl: './qa-field-errors-chart.component.css',
})
export class QaFieldErrorsChartComponent implements OnInit, OnChanges {
  @Input() items: FieldErrorChartItem[] = [];

  data: any;
  options: any;

  private wrongValueLabel: string = 'Wrong Value';
  private notExtractedLabel: string = 'Not Extracted';

  constructor(private translocoService: TranslocoService) { }

  ngOnInit(): void {
    this.translocoService.selectTranslate('admin.qa.wrong_value').subscribe((label) => {
      this.wrongValueLabel = label;
      this.updateChart();
    });

    this.translocoService.selectTranslate('admin.qa.not_extracted').subscribe((label) => {
      this.notExtractedLabel = label;
      this.updateChart();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.updateChart();
  }

  private updateChart(): void {
    Chart.register(ChartDataLabels);

    const labels = this.items.map(e => e.label);
    const wrongValue = this.items.map(e => e.wrong_value);
    const notExtracted = this.items.map(e => e.not_extracted);

    this.data = {
      labels,
      datasets: [
        {
          label: this.wrongValueLabel,
          data: wrongValue,
          backgroundColor: '#E57373',
          borderRadius: 4,
        },
        {
          label: this.notExtractedLabel,
          data: notExtracted,
          backgroundColor: '#FFB74D',
          borderRadius: 4,
        },
      ],
    };

    this.options = {
      indexAxis: 'y',
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            font: { family: 'Gilroy', size: 12 },
          },
        },
        datalabels: {
          display: (ctx: any) => ctx.dataset.data[ctx.dataIndex] > 0,
          anchor: 'center',
          align: 'center',
          color: '#FFFFFF',
          font: { size: 11, weight: 'bold', family: 'Gilroy' },
        },
        tooltip: {
          callbacks: {
            label: (ctx: any) => `${ctx.dataset.label}: ${ctx.raw}`,
          },
        },
      },
      scales: {
        x: {
          stacked: true,
          beginAtZero: true,
          ticks: {
            stepSize: 1,
            font: { family: 'Gilroy', size: 11 },
          },
          grid: { color: '#E0E0E0' },
        },
        y: {
          stacked: true,
          grid: { display: false },
          ticks: {
            font: { family: 'Gilroy', size: 11 },
          },
        },
      },
    };
  }
}
